<template>
  <span @click="anadir()">
    <v-tooltip bottom >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon :color="color" left> mdi-plus-box-outline </v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip ? $utilidades.traduccion({ texto: tooltip }) : $utilidades.traduccion({ texto: text }) }}</span>
    </v-tooltip>

  </span>
</template>

<script>
import { Utilidades } from "@/Util/Utilidades";
export default {
  name: "BtnAnadir",
  props: {
    rounded: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    textButton: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Nuevo", //Utilidades.traduccion({ texto: "Nuevo", tag: "NUEVO" }),
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "primary",
    },    
    tooltip: {
      type: String,
      default: "",
    },
  },
  components: {},
  methods: {
    anadir() {
      this.$emit("anadir");
    },
  },
};
</script>